import { render, staticRenderFns } from "./transactionChart.vue?vue&type=template&id=e74d4858"
import script from "./transactionChart.vue?vue&type=script&lang=js"
export * from "./transactionChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/Projects/PECOS/pecos_ivm_apiserver-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e74d4858')) {
      api.createRecord('e74d4858', component.options)
    } else {
      api.reload('e74d4858', component.options)
    }
    module.hot.accept("./transactionChart.vue?vue&type=template&id=e74d4858", function () {
      api.rerender('e74d4858', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/transactionChart.vue"
export default component.exports